/**
 * Placeholder risk & compliance data. Replace with the risk-engine API.
 */

// Same three colours the dashboard uses for risk, so a level keeps one colour
// across the whole app.
export const RISK_COLORS = {
  high: "#df3f45",
  medium: "#ef9c17",
  low: "#26a269",
};

export const RISK_STATS = [
  {
    key: "score",
    label: "Overall Risk Score",
    value: "68",
    unit: "/ 100",
    sub: "Medium Risk",
    progress: 68,
    progressTone: "warning",
    delta: "5.2 pts vs last period",
    direction: "up",
    tone: "blue",
    icon: "shield",
  },
  {
    key: "high",
    label: "High Risk Taxpayers",
    value: "2,156",
    sub: "12.4% of total taxpayers",
    delta: "8.7% vs last period",
    direction: "up",
    tone: "red",
    icon: "usersHigh",
  },
  {
    key: "medium",
    label: "Medium Risk Taxpayers",
    value: "5,478",
    sub: "31.6% of total taxpayers",
    delta: "3.1% vs last period",
    direction: "up",
    tone: "amber",
    icon: "usersMedium",
  },
  {
    key: "low",
    label: "Low Risk Taxpayers",
    value: "9,652",
    sub: "56.0% of total taxpayers",
    delta: "4.3% vs last period",
    direction: "down",
    tone: "green",
    icon: "usersLow",
  },
  {
    key: "compliance",
    label: "Compliance Rate",
    value: "92.4",
    unit: "%",
    sub: "Overall compliance",
    delta: "4.6% vs last period",
    direction: "up",
    tone: "blue",
    icon: "check",
  },
  {
    key: "cases",
    label: "Open Compliance Cases",
    value: "328",
    sub: "Requiring attention",
    delta: "9.3% vs last period",
    direction: "up",
    tone: "indigo",
    icon: "cases",
  },
];

export const TOTAL_TAXPAYERS = 17286;

export const RISK_DISTRIBUTION = [
  {
    label: "High Risk",
    value: 2156,
    share: 12.4,
    color: RISK_COLORS.high,
    legendPrimary: "2,156",
    legendSecondary: "(12.4%)",
  },
  {
    label: "Medium Risk",
    value: 5478,
    share: 31.6,
    color: RISK_COLORS.medium,
    legendPrimary: "5,478",
    legendSecondary: "(31.6%)",
  },
  {
    label: "Low Risk",
    value: 9652,
    share: 56.0,
    color: RISK_COLORS.low,
    legendPrimary: "9,652",
    legendSecondary: "(56.0%)",
  },
];

export const TREND_MONTHS = [
  "Jan 2026",
  "Feb 2026",
  "Mar 2026",
  "Apr 2026",
  "May 2026",
  "Jun 2026",
  "Jul 2026",
  "Aug 2026",
  "Sep 2026",
];

export const RISK_TREND = [
  {
    key: "high",
    label: "High Risk",
    color: RISK_COLORS.high,
    values: [2280, 2210, 2260, 2190, 2240, 2170, 2210, 2140, 2156],
  },
  {
    key: "medium",
    label: "Medium Risk",
    color: RISK_COLORS.medium,
    values: [1180, 1240, 1150, 1290, 1220, 1310, 1260, 1340, 1300],
  },
  {
    key: "low",
    label: "Low Risk",
    color: RISK_COLORS.low,
    values: [480, 520, 470, 560, 510, 590, 540, 620, 580],
  },
];

export const TREND_MAX = 3000;

/* -------------------------------------------------------------- heat map -- */

export const HEAT_ROWS = ["Very High", "High", "Medium", "Low", "Very Low"];
export const HEAT_COLS = ["Very Low", "Low", "Medium", "High", "Very High"];

export const HEAT_VALUES = [
  [0, 6, 18, 37, 52],
  [3, 14, 45, 78, 96],
  [12, 36, 98, 156, 112],
  [25, 68, 145, 132, 54],
  [40, 92, 128, 76, 28],
];

/* ------------------------------------------------------ high risk table -- */

export const TOTAL_HIGH_RISK = 2156;

export const INDUSTRIES = [
  "Trading",
  "Import/Export",
  "Oil & Gas Services",
  "Construction",
  "Manufacturing",
];

export const HIGH_RISK_TAXPAYERS = [
  {
    nif: "200-234-567",
    name: "Alpha Traders Ltd.",
    industry: "Trading",
    score: 28,
    level: "High",
    factor: "Underreporting, Related Parties",
    updatedDate: "01 Sep 2026",
    updatedTime: "09:32 AM",
  },
  {
    nif: "300-345-678",
    name: "Global Import & Export SA",
    industry: "Import/Export",
    score: 32,
    level: "High",
    factor: "Transfer Pricing, Customs Discrepancy",
    updatedDate: "01 Sep 2026",
    updatedTime: "09:15 AM",
  },
  {
    nif: "400-456-789",
    name: "PetroMax Services Ltd.",
    industry: "Oil & Gas Services",
    score: 35,
    level: "High",
    factor: "Large Deductions, VAT Risk",
    updatedDate: "01 Sep 2026",
    updatedTime: "08:47 AM",
  },
  {
    nif: "600-789-012",
    name: "Sunrise Construction Lda.",
    industry: "Construction",
    score: 38,
    level: "High",
    factor: "Cash Transactions, Non-compliance",
    updatedDate: "01 Sep 2026",
    updatedTime: "08:21 AM",
  },
  {
    nif: "100-123-456",
    name: "Blue Horizon Ltd.",
    industry: "Manufacturing",
    score: 42,
    level: "High",
    factor: "Related Parties, Thin Capitalization",
    updatedDate: "01 Sep 2026",
    updatedTime: "07:55 AM",
  },
];

export const RISK_FACTORS = [
  { label: "Underreporting of Income", count: "1,256", icon: "user" },
  { label: "Related Party Transactions", count: "982", icon: "users" },
  { label: "VAT Non-Compliance", count: "873", icon: "doc" },
  { label: "Cash Intensive Operations", count: "612", icon: "cash" },
  { label: "Transfer Pricing Risk", count: "489", icon: "network" },
];

export const COMPLIANCE_ALERTS = [
  {
    id: 1,
    title: "High risk taxpayer detected",
    who: "Alpha Traders Ltd. (200-234-567)",
    when: "01 Sep 2026, 09:32 AM",
    severity: "high",
  },
  {
    id: 2,
    title: "Potential VAT discrepancy",
    who: "Global Import & Export SA (300-345-678)",
    when: "01 Sep 2026, 09:15 AM",
    severity: "medium",
  },
  {
    id: 3,
    title: "Missing Filing",
    who: "PetroMax Services Ltd. (400-456-789)",
    when: "01 Sep 2026, 08:47 AM",
    severity: "low",
  },
];
